import { render, staticRenderFns } from "./HandBookCard.vue?vue&type=template&id=295dec0c"
import script from "./HandBookCard.vue?vue&type=script&lang=js"
export * from "./HandBookCard.vue?vue&type=script&lang=js"
import style0 from "./HandBookCard.vue?vue&type=style&index=0&id=295dec0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports